import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { useQueryClient } from '@tanstack/react-query'
import { useAppSelector } from '@core/Store/hooks'
import { getTrustedDeviceDetails } from '@core/Areas/Login/Store/selectors'
import { rememberTrustedDevice } from '@core/Areas/Login/Store'
import { registerTrustedDevice } from '@core/Areas/Login/helpers/api'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { mfaDevicesQueryKey } from './useMfaDevices'

export const useTrustDevice = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const trustedDevices = useAppSelector(getTrustedDeviceDetails)

  async function trustDevice(accountNumber: number) {
    try {
      const trustedDevice = trustedDevices[accountNumber]

      if (trustedDevice) {
        const { deviceKey, deviceGroupKey, deviceSecret } = trustedDevice
        const accountIdentifier = accountNumber.toString()

        await registerTrustedDevice({
          deviceGroupKey,
          deviceKey,
          deviceSecret,
        })

        dispatch(
          rememberTrustedDevice({
            accountIdentifier,
          })
        )

        queryClient.invalidateQueries({
          queryKey: mfaDevicesQueryKey(accountNumber),
        })

        addToast({
          id: 'trusted-device-success',
          title: 'Trusted device registered',
          subtitle:
            'You will no longer be prompted for a verification code to log in on this device',
          icon: 'success',
        })
      }
    } catch {
      addToast({
        id: 'trusted-device-error',
        isDismissable: true,
        timeoutMs: Infinity,
        title: 'Trusted Devices',
        subtitle: 'Adding your device was unsuccessful.',
        button: {
          text: 'Manage',
          onClick: () => navigate('/account/settings/mfa'),
        },
        icon: 'error',
      })
    }
  }
  return { trustDevice }
}
